import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const App = () => {
  const [searchParams] = useSearchParams();
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    const fetchRedirect = async () => {
      const bucketName = "aberdeen-qr-codes";
      let key = searchParams.get('Key') || searchParams.get('key');

      if (!key) {
        setErrorMessage('Key is missing in the query string. Please provide a valid key.');
        return;
      }

      const objectUrl = `https://${bucketName}.s3.us-east-1.amazonaws.com/${key}`;

      try {
        const response = await fetch(objectUrl, {
          method: 'HEAD',
        });

        if (!response.ok) {
          if (response.status === 404) {
            setErrorMessage('The requested object was not found in S3.');
          } else {
            setErrorMessage('Failed to fetch the object metadata. Please try again.');
          }
          return;
        }

        const redirectUrl = response.headers.get('x-amz-website-redirect-location');

        if (redirectUrl) {
          window.location.href = redirectUrl;
        } else {
          setErrorMessage('No redirect URL found in the object metadata.');
        }
      } catch (error) {
        setErrorMessage('An error occurred while fetching the object metadata. Please try again.');
      }
    };

    fetchRedirect();
  }, [searchParams]);

  return (
    <div>
      {errorMessage ? (
        <div style={{ color: 'red', textAlign: 'center', marginTop: '20px' }}>
          <h2>Error</h2>
          <p>{errorMessage}</p>
        </div>
      ) : (
        <h1>Redirecting...</h1>
      )}
    </div>
  );
};

export default App;
